import React from 'react'

const ArrowUp = () => {
    return (
        <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.13334 0.646446C3.93808 0.451184 3.62149 0.451184 3.42623 0.646446L0.244251 3.82843C0.0489891 4.02369 0.0489891 4.34027 0.244251 4.53553C0.439513 4.7308 0.756096 4.7308 0.951358 4.53553L3.77979 1.70711L6.60821 4.53553C6.80347 4.7308 7.12006 4.7308 7.31532 4.53553C7.51058 4.34027 7.51058 4.02369 7.31532 3.82843L4.13334 0.646446ZM4.27979 10L4.27979 1H3.27979L3.27979 10H4.27979Z" fill="#696969" />
        </svg>

    )
}

export default ArrowUp